<template>
  <div class="login-container">
    <div class="bg-lx">
      <div class="lxp" v-for="i in 1000" :key="i">
        <div class="lx"></div>
      </div>
    </div>
    <div class="imgBox">
      <img src="@/assets/images/login.png"/>
    </div>

    <!-- 标题盒子 -->
    <div class="title-box">
      <div class="title">ID查询后台</div>
      <div class="buleTitle">用户登录 <span>USER LOGIN</span></div>
      <!-- 表单 -->
      <el-form class="login-form"  @submit.native.prevent="login">
        <!-- 手机号 -->
        <el-form-item prop="phone" class="login-item">
          <el-input
              v-model="username"
              class="high-input"
              prefix-icon="el-icon-user"
              placeholder="账户名"
          ></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password" class="login-item">
          <el-input
              v-model="password"
              class="high-input"
              show-password
              prefix-icon="el-icon-lock"
              placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-item">
          <div class="flex" v-loading="captchaloadin" >
            <el-input
                v-model="code"
                style="flex: 1"
                prefix-icon="el-icon-document-checked"
                class="code-input"
                placeholder="验证码"
            ></el-input>
            <img   @click="captcha"  :src="catpcha.image_64" alt="" class="codeSrc"/>
          </div>

        </el-form-item>
        <el-form-item>
          <el-button
              :loading="loading"
              class="login-btn"
              native-type="submit"
              type="primary"
          >{{ loading ? "登陆中" : "登录" }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {captcha} from "@/request/api/passpord";

export default {
  data() {
    return {
      loading: false,
      username: "",
      password: "",
      code:"",
      captchaloadin:false,
      catpcha: {
        image_64: '',
        guid: ''
      },
    };
  },
  created() {
    this.captcha();
  },
  methods: {
    captcha() {
      this.captchaloadin = true;
      captcha().then(res => {
        this.catpcha = res;
        this.captchaloadin = false;
      }).catch(() => {
        this.captchaloadin = true;
      })
    },
    login() {
      this.loading = true;
      this.$store
          .dispatch("admin/Login", {
            username: this.username,
            password: this.password,
            guid: this.catpcha.guid,
            code: this.code,
          })
          .then(() => {
            this.loading = false;

            this.$router.push("/dashboard/index");
            this.greet();
          })
          .catch(() => {
            this.loading = false;
			this.captcha();
          });
    },
    greet() {
      var now = new Date(),
          hour = now.getHours();
      let msg = "凌晨好！";
      if (hour < 6) {
        msg = "凌晨好！";
      } else if (hour < 9) {
        msg = "早上好！";
      } else if (hour < 12) {
        msg = "上午好！";
      } else if (hour < 14) {
        msg = "中午好！";
      } else if (hour < 17) {
        msg = "下午好！";
      } else if (hour < 19) {
        msg = "傍晚好！";
      } else if (hour < 22) {
        msg = "晚上好！";
      } else {
        msg = "夜里好！";
      }
      let adminInfo = this.$store.getters.info;
      let html = `<p class="flex"><span style="width: 80px">上次登录：</span><b>${adminInfo.last_time}</b></p>`;
      this.$notify({
        title: msg + adminInfo.username,
        dangerouslyUseHTMLString: true,
        message: html,
        position: "bottom-right",
      });
    },
  },
};
</script>

<style lang="scss">
.bg-lx {
  width: 80%;
  overflow: hidden;
  position: fixed;
}

.lxp {
  width: 160px;
  height: 160px;
  transform: rotateX(45deg);
  margin-right: 50px;
  float: left;
  margin-top: -10px;
}

.lx {
  width: 150px;
  height: 150px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transform: rotate(45deg);
}

.imgBox {
  position: absolute;
  height: 539px;
  width: 887px;
  top: calc((100vh - 539px) / 2);
  left: 70px;

  img {
    height: 539px;
    width: 887px;
  }
}

.login-container {
  background: linear-gradient(
          90deg,
          rgba(50, 102, 250, 1),
          rgba(12, 135, 255, 1)
  );
  width: 100vw;
  height: 100vh;
  display: flex;
  position: relative;
  // 标题盒子
  .title-box {
    width: 508px;
    height: 606px;
    background: #ffffff;
    border-radius: 10px;
    position: absolute;
    top: calc((100vh - 606px) / 2);
    right: 15%;
    padding: 80px 80px 0 80px;

    .title {
      display: block;
      //text-align: center;
      font-size: 38px;
      font-weight: bold;
      color: #292c2f;
    }

    .buleTitle {
      font-size: 32px;
      //font-weight: bold;
      color: #007eff;
      display: block;
      //text-align: center;
      margin-top: 48px;
      margin-bottom: 32px;

      span {
        color: #999999;
        font-size: 24px;
      }
    }

    // 登录表单
    .login-form {
      width: 100%;

      .login-item {
        margin-bottom: 30px;
      }

      .el-input__inner {
        width: 100%;
        border-radius: 26px;
        height: 52px;
      }

      .el-input .el-input__clear {
        margin-left: -10px;
      }

      .el-input__icon {
        margin-top: 2px;
        font-size: 18px;
      }

      .el-form-item__content {
        height: 40px;
      }

      .changeBtn {
        color: #007eff;
        border: none;
        background-color: white;
        font-size: 20px;
        position: absolute;
        right: 0;
        //top: 10px;
      }

      .codeSrc {
        width: 200px;
        height: 52px;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    // 表单内部的 按钮
    .login-btn {
      width: 100%;
      border-radius: 26px;
      height: 52px;
      font-size: 17px;
      letter-spacing: 4px;
      margin-top: 20px;
    }
  }
}

@media screen and (max-width: 1600px) {
  .imgBox {
    left: -80px;
  }
  .title-box {
    right: 5% !important;
  }
}

@media screen and (max-width: 1200px) {
  .imgBox {
    display: none;
  }
  .bg-lx {
    width: 100%;
  }
  .title-box {
    left: calc((100vw - 508px) / 2);
  }
}
</style>
